import { ProjectSourceType } from '@common/types';
import { useIsVappImportProjectEnabled } from '@common/VerticalApps/hooks';
import CreateProject from '@pages/CreateEntity/Project';
import { useSearchParams } from 'react-router-dom';

import Home from '../Home';

export default function CreateProjectPage() {
  const [searchParams] = useSearchParams();

  const projectType = searchParams.get('projectType');

  const isVappImportProjectEnabled = useIsVappImportProjectEnabled();

  if (projectType === ProjectSourceType.imported && isVappImportProjectEnabled) {
    return <CreateProject />;
  }

  return <Home isCreateProjectPage={true} />;
}
